// External Dependencies:
import React from 'react'
import { Link, NavLink } from 'react-router-dom'

class NewsPage extends React.Component {
	handleClick = () => {
		// Fallback for when the app isn't installed:
		setTimeout( () => {
			window.location = 'https://www.facebook.com/faithfmaustralia/'
		}, 25 )

		window.location = 'fb://faithfmaustralia'
	}

	render() {
		return (
			<div className="mobile-app-top-page">
				<div className="-bg"></div>

				<div className="-menu">
					<span onClick={ this.handleClick }>Facebook</span>
					<a href="https://www.youtube.com/faithfmaustralia">YouTube</a>
					<a href="https://www.instagram.com/faithfmaustralia">Instagram</a>
					<a href="https://twitter.com/faithfmlive">Twitter</a>
				</div>
			</div>
		)
	}
}

export default NewsPage
